module.exports = __webpack_public_path__ + "img/preview-13.59807f81.jpg";